<script>
import { hasDeepValue, has } from "has-deep-value";
import moment from "moment";
const queryString = require("query-string");
import SHA256 from "crypto-js/sha256";
import CryptoJS from "crypto-js";
const ranges = [
  {
    divider: 1e3,
    suffix: "K",
  },
  {
    divider: 1e6,
    suffix: "M",
  },
  {
    divider: 1e9,
    suffix: "B",
  },
];

export default {
  mounted() { },
  methods: {
    moment,
    hasDeepValue,
    $validateCurrencyLabel(value) {
      if (value == "USD") {
        return "$";
      } else {
        return value;
      }
    },
    $formatMoney(amount, decimalCount = 0, decimal = ".", thousands = ",", currency = "RWF") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          `${currency == "USD" ? '$' : currency + ' '}` +
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
            : "")
        );
      } catch (e) {
        console.log(e);
      }
    },
    $formatNumber(input) {
      for (let index = ranges.length - 1; index >= 0; index--) {
        if (input > ranges[index].divider) {
          let quotient = input / ranges[index].divider;

          if (quotient < 10) {
            quotient = Math.floor(quotient * 10) / 10;
          } else {
            quotient = Math.floor(quotient);
          }

          return quotient.toString() + ranges[index].suffix;
        }
      }

      return input.toString();
    },
    $cutText(str, maxLen, separator = " ") {
      if (str.length <= maxLen) return str;
      return str.substr(0, str.lastIndexOf(separator, maxLen)) + " ...";
    },
    $fetchFromObject(obj, prop) {
      let vm = this;
      if (typeof obj === "undefined") return false;
      var _index = prop.indexOf(".");
      if (_index > -1) {
        return vm.$fetchFromObject(
          obj[prop.substring(0, _index)],
          prop.substr(_index + 1)
        );
      }
      if (obj[prop] && obj[prop] != "null" && obj[prop] != "") {
        return true;
      } else {
        return false;
      }
    },
    $hasKey(obj, keyString) {
      let vm = this;
      if (vm.hasDeepValue(obj, keyString)) {
        if (vm.$fetchFromObject(obj, keyString)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    $isRouter(name) {
      if (this.$route.name === name) {
        return true;
      } else {
        return false;
      }
    },
    $getUserAccessToken() {
      let vm = this;
      if (vm.$localStorage.get("user_data")) {
        let user_data = JSON.parse(vm.$localStorage.get("user_data"));
        return user_data.access_token;
      } else {
        return "";
      }
    },
    $getLoggedUser() {
      let vm = this;
      if (vm.$localStorage.get("user_data")) {
        let user_data = JSON.parse(vm.$localStorage.get("user_data"));
        return user_data;
      } else {
        return false;
      }
    },
    $saveLoginInfo(data) {
      let vm = this;
      vm.$localStorage.set("user_data", JSON.stringify(data));
      vm.$store.commit("SET_TOKEN", data.access_token);
    },
    $setRedirect(path) {
      let vm = this;
      vm.$localStorage.set("redirect_path", path);
    },
    $appRedirect() {
      let vm = this;
      if (vm.$localStorage.get("redirect_path")) {
        vm.$router.push({ name: vm.$localStorage.get("redirect_path") });
        vm.$localStorage.remove("redirect_path");
      } else {
        vm.$router.push({ name: "dashboard" });
      }
    },
    $isFieldsValidated(form, rules, length = 10000) {
      let vm = this;
      let is_error = false;
      Object.keys(rules).forEach((key, index) => {
        if (index < length - 1) {
          if (rules[key].run(form[key])) {
            let error_message = rules[key].run(form[key]);
            if (error_message) {
              if (!is_error) {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: error_message,
                });
              }
              is_error = true;
            }
          }
        }
      });
      return !is_error;
    },
    $nameInitials(name) {
      var initials = name.match(/\b\w/g) || [];
      initials = (
        (initials.shift() || "") + (initials.pop() || "")
      ).toUpperCase();
      return initials;
    },
    $checkPermission(permission_key) {
      let vm = this;
      if (
        vm.$getLoggedUser() &&
        vm.$getLoggedUser().user &&
        vm.$getLoggedUser().user.permissions
      ) {
        if (vm.$getLoggedUser().user.email == "ajahwin@gmail.com") {
          return true;
        } else {
          const permissions = vm.$getLoggedUser().user.permissions;
          const permission_item = permissions.find((permission) => {
            if (permission.permission_key === permission_key) {
              return true;
            }
          });
          return permission_item && permission_item.enabled == 1 ? true : false;
        }
      } else {
        return false;
      }
    },
    addCountries(url, a, b) {
      var tempUrl = url;
      if (a != null) {
        var tempUrlOne = new URL(tempUrl);
        tempUrl +=
          (tempUrlOne.search == "" ? "?" : "&") + "token_countries=" + a;
      }
      if (b != null) {
        var tempUrlTwo = new URL(tempUrl);
        tempUrl +=
          (tempUrlTwo.search == "" ? "?" : "&") +
          "token_countries_blocked=" +
          b;
      }
      return tempUrl;
    },
    BunnCDNSignUrl(
      url,
      securityKey,
      expirationTime = 3600,
      userIp,
      isDirectory = false,
      pathAllowed,
      countriesAllowed,
      countriesBlocked
    ) {
      var parameterData = "",
        parameterDataUrl = "",
        signaturePath = "",
        hashableBase = "",
        token = "";
      var expires = Math.floor(new Date() / 1000) + expirationTime;
      var url = this.addCountries(url, countriesAllowed, countriesBlocked);
      var parsedUrl = new URL(url);
      var parameters = new URL(url).searchParams;
      if (pathAllowed != null) {
        signaturePath = pathAllowed;
        parameters.set("token_path", signaturePath);
      } else {
        signaturePath = parsedUrl.pathname;
      }
      parameters.sort();
      if (Array.from(parameters).length > 0) {
        parameters.forEach(function (value, key) {
          if (parameterData.length > 0) {
            parameterData += "&";
          }
          parameterData += key + "=" + value;
          parameterDataUrl += "&" + key + "=" + queryString.stringify(value);
        });
      }
      hashableBase =
        securityKey +
        signaturePath +
        expires +
        (userIp != null ? userIp : "") +
        parameterData;
      token = SHA256(hashableBase).toString(CryptoJS.enc.Base64);
      token = token
        .replace(/\n/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
      if (isDirectory) {
        return (
          parsedUrl.protocol +
          "//" +
          parsedUrl.host +
          "/bcdn_token=" +
          token +
          parameterDataUrl +
          "&expires=" +
          expires +
          parsedUrl.pathname
        );
      } else {
        return (
          parsedUrl.protocol +
          "//" +
          parsedUrl.host +
          parsedUrl.pathname +
          "?token=" +
          token +
          parameterDataUrl +
          "&expires=" +
          expires
        );
      }
    },
    token(length = 1) {
      let token = "";
      for (let i = 0; i < length; i++) {
        token += Math.random().toString(36).substr(2);
      }
      return token;
    },
    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    getUrlPath(url) {
      var el = document.createElement("a");
      el.href = url;
      return el.pathname;
    },
    getFileName(url) {
      return url.split("/").pop();
    },
    get_url_extension(url) {
      return url.split(/[#?]/)[0].split(".").pop().trim();
    },
    $GetExt(file) {
      return /(?:\.([^.]+))?$/.exec(file)[1];
    },
    processResponce(responce) {
      let vm = this;
      let encryption = vm.Encryption();
      var decrypted = encryption.decrypt(
        responce,
        "C*gtbU(|SnTgjf}#9b))GT.]5Bmfg)Y0YDwkTm.uYAHn{Fi78A6m@fcjfB/|YzF"
      );
      return decrypted;
    },
    toHHMMSS(ss) {
      var sec_num = parseInt(ss, 10);
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    },
    fileSizeConvert(incommingBytes) {
      var bytes = parseFloat(incommingBytes);
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    $getPartnerSiteBaseUrl() {
      let vm = this;
      const loggedUser = vm.$getLoggedUser();

      if (loggedUser && loggedUser.user && loggedUser.user.domain) {
        const domain = loggedUser.user.domain.trim().replace(/^https?:\/\//i, "").replace(/\/+$/, "");

        if (domain) {
          return `https://${domain}/`;
        }
      }

      return vm.$store.state.SITE_BASE_URL;
    },

  },

};
</script>
